import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type POPDFLabelSetNameFormSchema } from '@webapp/modules/purchasing/components/POPDFLabelSetNameForm'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'
import { pdfLabelSetRepository } from '@webapp/modules/vendor/data-access/repositories/PDFLabelSetRepository' // eslint-disable-line import/no-internal-modules
import {
  PDFLabelSet,
  type OrderItemLabels,
  type PDFLabelSetConstructor,
  type POLabels,
} from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules
import { pdfLabelSetQueryConfig } from '@webapp/modules/vendor/query-configs/pdf-label-set' // eslint-disable-line import/no-internal-modules

export const useMutateCreatePOPDFLabelSet = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    PDFLabelSet,
    RepoError,
    POPDFLabelSetNameFormSchema
  >({
    mutationFn: async (values: POPDFLabelSetNameFormSchema) => {
      // Key is derived from the name (Angular Business Rule); the server
      // answers with the canonical stored key
      const payload: PDFLabelSetConstructor = {
        isPrimary: false,
        key: values.name,
        value: {
          name: values.name,
          po: {} as POLabels,
          orderitem: {} as OrderItemLabels,
        },
      }

      const { key } = await pdfLabelSetRepository.create(payload)

      return new PDFLabelSet({ ...payload, key })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: pdfLabelSetQueryConfig.all().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: poPdfLabelEditorQueryConfig.initialSet().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
